<template>
  <div class="container-item image-card mt-5 mb-5">  
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-9 col-xl-8 col-12">
        <div class="embed-responsive embed-responsive-16by9 text-center">
          <iframe id="foco_video_minidoc_item" src="https://www.youtube.com/embed/FzZEKqjVaE0?si=hy8WmCGhTQquncWs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>    
  </div>
</template>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'SingleVideo',
    mixins: [images],
    props: {
      cardText: Object 
    }
  }
</script>